var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarmDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 26.4727H34V29.2727H6V26.4727H8.8V16.6727C8.8 13.7022 9.98 10.8535 12.0804 8.75306C14.1808 6.65265 17.0296 5.47266 20 5.47266C22.9704 5.47266 25.8192 6.65265 27.9196 8.75306C30.02 10.8535 31.2 13.7022 31.2 16.6727V26.4727ZM28.4 26.4727V16.6727C28.4 14.4448 27.515 12.3083 25.9397 10.733C24.3644 9.15765 22.2278 8.27266 20 8.27266C17.7722 8.27266 15.6356 9.15765 14.0603 10.733C12.485 12.3083 11.6 14.4448 11.6 16.6727V26.4727H28.4ZM15.8 32.0727H24.2V34.8727H15.8V32.0727Z",
    fill: "#8E96A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmDefault);
export default __webpack_public_path__ + "static/media/icon_alarm_default.fa4021b3253e47244b54270d527cda8d.svg";
export { ForwardRef as ReactComponent };